<div class="create-course">
  <div *ngIf="showSpinner" class="progress-spinner">
    <mat-spinner class="mat-spinner-color"></mat-spinner>
  </div>
  <mat-card-title class="mat-display-1 mb-5">
    <span>Demokratiewerkstatt Erstellen</span>
  </mat-card-title>
  <div class="form">
    <mat-card>
      <mat-card-content>
        <div class="new-form">
          <form [formGroup]="demokratiewerkstattForm" (ngSubmit)="submitForm()">
            <div class="mb-2">
              <div class="title1">
                <span class="projName">Demokratiewerkstatt Titel*</span>
                <div class="subtitle1">
                  <input class="inputTitle" formControlName="title" label="Demokratiewerkstatt titel" placeholder="Ihr Titel hier"/>
                </div>
              </div>
              <span class="note">Mindestens 4 Zeichen</span>
            </div>

            <div class="mb-2">
              <div class="titleDate">
                <span class="projName">Wann*</span>
                <div class="subtitle1">
                  <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate formControlName="start_date" placeholder="Start"
                           style="color: #fff !important"/>
                    <input style="color: #fff !important" matEndDate formControlName="end_date" placeholder="End"
                           style="color: #fff !important"/>
                  </mat-date-range-input>

                  <mat-datepicker-toggle style="color: #fff !important" matIconSuffix
                                         [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </div>
              </div>
              <span class="note">DD/MM/YYYY - DD/MM/YYYY</span>
            </div>
            <div class="mb-2">
              <div class="title1">
                <span class="projName">Wo*</span>
                <div class="subtitle1">
                  <input class="inputTitle" formControlName="location" label="Demokratiewerkstatt location"
                         placeholder="Adresse"/>
                </div>
              </div>
            </div>

            <div class="mb-5">
              <ngx-dropzone class="selectImage" (change)="onSelectLogo($event)">
                <ngx-dropzone-label>Demokratiewerkstatt logo ziehen und ablegen</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of logoFile" [removable]="true" (removed)="onRemoveLogo(f)">
                  <ngx-dropzone-label>
                    <img [src]="previewLogoDemokratiewerkstatt" alt="f.name" class="preview-image"/>
                  </ngx-dropzone-label>
                </ngx-dropzone-preview>
              </ngx-dropzone>

            </div>

            <div class="mb-5">
              <ngx-dropzone class="selectImage" (change)="onSelectImageProject($event)">
                <ngx-dropzone-label>Demokratiewerkstattbild ziehen und ablegen</ngx-dropzone-label>

                <ngx-dropzone-preview *ngFor="let f of imageDemokratiewerkstatt" [removable]="true"
                                      (removed)="onRemoveImageProject(f)">
                  <ngx-dropzone-label>
                    <img [src]="previewDemokratiewerkstattImage" alt="f.name" class="preview-image"
                         style="width: 100px; height: 100px; "/>
                  </ngx-dropzone-label>
                </ngx-dropzone-preview>
              </ngx-dropzone>
            </div>

            <div class="mb-5">
              <ngx-dropzone class="selectImage" (change)="onSelectSponsorImage($event)">
                <ngx-dropzone-label>Ziehen und Ablegen von Sponsorenbildern</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of previewSponsorImage" [removable]="true"
                                      (removed)="onRemoveSponsorImage(f)">
                  <ngx-dropzone-label class="sponsor-images">
                    <img [src]="f" alt="f.name" class="preview-image"/>
                  </ngx-dropzone-label>
                </ngx-dropzone-preview>
              </ngx-dropzone>
            </div>

            <div class="mb-5">
              <ngx-dropzone class="selectImage" (change)="onSelectPartnersImage($event)">
                <ngx-dropzone-label>Ziehen und Ablegen von PartnerImages</ngx-dropzone-label>
                <ngx-dropzone-preview *ngFor="let f of previewParnersImage" [removable]="true"
                                      (removed)="onRemoveParnersImages(f)">
                  <ngx-dropzone-label class="sponsor-images">
                    <img [src]="f" alt="f.name" class="preview-image"/>
                  </ngx-dropzone-label>
                </ngx-dropzone-preview>
              </ngx-dropzone>
            </div>


            <div class="form-group bg-dark mb-3 content">
              <label>Beschreibung*</label>
              <app-rich-text-editor [control]="contentControl"></app-rich-text-editor>
            </div>

            <mat-card-actions>
              <button mat-raised-button color="primary" [disabled]="demokratiewerkstattForm.invalid">
                Speichern
              </button>
            </mat-card-actions>
          </form>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card *ngIf="demokratiewerkstattPreview$ | async as demokratiewerkstatt" class="preview">
      <h1>Vorschau</h1>
      <mat-card-header>
        <mat-card-title>{{ demokratiewerkstatt.title }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="properties">
          <div *ngIf="demokratiewerkstatt.start_date">
            <p class="label">Wann:</p>
            <p class="value">
              {{ demokratiewerkstatt.start_date | date }} - {{ demokratiewerkstatt.end_date | date }}
            </p>
          </div>
          <div *ngIf="demokratiewerkstatt.location">
            <p class="label">Wo:</p>
            <p class="value">{{ demokratiewerkstatt.location }}</p>
          </div>

          <div
            *ngIf="demokratiewerkstatt.demokratiewerkstatt_icon_url && demokratiewerkstatt.demokratiewerkstatt_icon_url !== '' && previewLogoDemokratiewerkstatt === ''">
            <p class="label">Demokratiewerkstattlogo:</p>
            <p class="value">
              <img [src]="demokratiewerkstatt.demokratiewerkstatt_icon_url" alt=""/>
            </p>
          </div>
          <div *ngIf="previewLogoDemokratiewerkstatt !== ''">
            <p class="label">Demokratiewerkstattlogo:</p>
            <p class="value">
              <img [src]="previewLogoDemokratiewerkstatt" alt=""/>
            </p>
          </div>
          <div
            *ngIf="demokratiewerkstatt.demokratiewerkstatt_image_url && demokratiewerkstatt.demokratiewerkstatt_image_url !== '' && previewDemokratiewerkstattImage === ''">
            <p class="label">Demokratiewerkstattbild-URL:</p>
            <p class="value">
              <img [src]="demokratiewerkstatt.demokratiewerkstatt_image_url" alt=""/>
            </p>
          </div>
          <div *ngIf="previewDemokratiewerkstattImage !== ''">
            <p class="label">Demokratiewerkstattbild-URL:</p>
            <p class="value">
              <img [src]="previewDemokratiewerkstattImage" alt=""/>
            </p>
          </div>
          <div
            *ngIf="demokratiewerkstatt.sponsor_images_url && demokratiewerkstatt.sponsor_images_url.length > 0 && previewSponsorImage.length === 0">
            <p class="label">Demokratiewerkstattsponsor Bild-URL:</p>
            <p class="value" *ngFor="let url of demokratiewerkstatt.sponsor_images_url">
              <img [src]="url" alt=""/>
            </p>
          </div>
          <div *ngIf="previewSponsorImage.length !== 0">
            <p class="label">Demokratiewerkstattsponsor Bild-URL:</p>
            <p class="value" *ngFor="let url of previewSponsorImage">
              <img [src]="url" alt=""/>
            </p>
          </div>
          <div>
            <div
              *ngIf="demokratiewerkstatt.partners_images_url && demokratiewerkstatt.partners_images_url.length > 0 && previewParnersImage.length === 0">
              <p class="label">Demokratiewerkstattparner Bild-URL:</p>
              <p class="value" *ngFor="let url of demokratiewerkstatt.partners_images_url">
                <img [src]="url" alt=""/>
              </p>
            </div>
            <div *ngIf="previewParnersImage.length !== 0">
              <p class="label">Demokratiewerkstattpartner Bild-URL:</p>
              <p class="value" *ngFor="let url of previewParnersImage">
                <img [src]="url" alt=""/>
              </p>
            </div>
          </div>
          <div *ngIf="demokratiewerkstatt.director">
            <p class="label">Direktor:</p>
            <p class="value">{{ demokratiewerkstatt.director }}</p>
          </div>
          <div *ngIf="demokratiewerkstatt.code">
            <p class="label">Code:</p>
            <p class="value">{{ demokratiewerkstatt.code }}</p>
          </div>
        </div>
        <div [innerHTML]="demokratiewerkstatt.content" class="preview-content"></div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
